import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import LinkButton from 'ember-simplepractice/components/spds/action/button/link';
import SharedToggleSwitch from 'ember-simplepractice/components/shared/toggle-switch';
import styles from './away-message-section.module.scss';

export default class AwayMessageSection extends Component {
  @service messaging;
  @service alertManager;
  @service intl;

  get isAway() {
    return this.messaging.currentProfile?.isAway || false;
  }

  get statusText() {
    return this.intl.t(`emc.away_status.${this.isAway}`);
  }

  @action
  async onToggle(checked) {
    try {
      await this.messaging.toggleAwayStatus.perform(checked);

      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.away_status.update_success', {
          status: this.statusText,
        }),
        type: 'success',
      });
    } catch (error) {
      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.away_status.update_failed'),
        type: 'error',
      });
    }
  }

  @action
  onCustomizeClick() {
    this.messaging.toggleAwayStatusCustomizing();
  }

  <template>
    <div class="{{styles.component}} away-message-section" data-test-away-message-section>
      <div class="away-message-status">
        <p class="status-text">
          Away message to clients is
          <span class="status-indicator {{this.statusText}}">{{this.statusText}}</span>
        </p>

        <LinkButton {{on "click" this.onCustomizeClick}}>Customize</LinkButton>
      </div>
      <SharedToggleSwitch class="small" @checked={{this.isAway}} @onSwitch={{this.onToggle}} />
    </div>
  </template>
}
